import { Injectable } from "@angular/core";
import { AbstractService } from "../core/AbstractService";
import { RegroupeExpressionBesoinReq } from "../data/http/requests/regroupementexpressionbesoin.req";
import { RegroupeExpressionBesoinRes } from "../data/http/responses/regroupementexpressionbesoin.res";
import { HttpClient } from "@angular/common/http";
import { AppService } from "../core/app.service";
import { env } from "../../env/env";

@Injectable({
    providedIn: 'root'
})
export class RegroupementExpressionBesoinService extends AbstractService<RegroupeExpressionBesoinReq, RegroupeExpressionBesoinRes> {
    constructor(http: HttpClient, AppService: AppService) {
        super(`${env.apiUrl}expression-besoin-marche`, http, AppService); 
    }
}